import { xhrRequest, infoDialogBox, displayMoreFlag } from '../../shared/helpers'

// Some Constants...
const STAR_STATES = [ 'not_starred', 'starred_for_user', 'starred_for_everyone' ]
const CSS_CLASSES_BY_STATE = {
  'not_starred': 'starrable-star fa fa-star',
  'starred_for_user': 'starrable-star far fa-star starred',
  'starred_for_everyone': 'starrable-star fa fa-star starred'
}

export default class extends Controller {
  static targets = ['star', 'dialog']

  connect() {
    this.ajaxURL = this.data.get('url')
  }

  updateStarred(event) {
    event.preventDefault();
    const nextState = this.getNextState();
    xhrRequest(this.ajaxURL, 'post', {
      state: nextState
    })
      .then(res => {
        this.starTarget.className = this.getNewClass(nextState);
        this.starState = nextState;
        this.updateCounterpartStar(nextState);
        this.dialogTarget.innerHTML = this.getInfoDialog(this.infoContent(nextState));
        this.refreshStarsCard();
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => { this.dialogTarget.innerHTML = '' }, 3000);
      })
  }

  //
  // PRIVATE FUNCTIONS
  //

  getNextState() {
    const len = STAR_STATES.length
    const incIndex = STAR_STATES.indexOf(this.starState) + 1
    return STAR_STATES[incIndex >= len ? 0 : incIndex]
  }

  getNewClass(state) {
    return CSS_CLASSES_BY_STATE[state];
  }

  refreshStarsCard() {
    const container = this.data.has('starsCardContainerId') &&
      document.getElementById(this.data.get('starsCardContainerId'))
    const url = this.data.has('starsCardUpdateUrl') &&
      this.data.get('starsCardUpdateUrl')
    if (container && url.length > 0) {
      xhrRequest(url, 'get', {})
        .then(res => {
          container.innerHTML = res.data.html;
          displayMoreFlag(document.querySelectorAll('.scrollable-starred-items-container')); // display the '.more' signifier if the items overflow
        })
    }
  }

  getInfoDialog(content) {
    if (content) {
      return (
        `<div class="star-info-box">
          <div class="star-info-absolute">
            ${infoDialogBox(content)}
          </div>
        </div>`
      )
    } else {
      return ''
    }
  }

  infoContent(state) {
    switch(state) {
      case STAR_STATES[1]:
        return 'Starred for You'
      case STAR_STATES[2]:
        return 'Starred for Everyone'
      default:
        return null
    }
  }

  getCounterpartStar() {
    const id = this.element.id || ''
    const counterpartID = this.element.classList.contains('mobile') ? id.replace('mobile', 'desktop') : id.replace('desktop', 'mobile')
    return document.getElementById(counterpartID)
  }

  updateCounterpartStar(newState) {
    const counterpart = this.getCounterpartStar()
    if (!counterpart) return;
    counterpart.dataset.starsState = newState
    counterpart.querySelector('i').className = this.getNewClass(newState)
  }

  getNewState(newState) {
    return CSS_CLASSES_BY_STATE[newState]
  }

  //
  // GETTERS AND SETTERS
  //

  get starState() {
    return this.data.get('state')
  }

  set starState(value) {
    this.data.set('state', value)
    this.renderStarClass
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/stars/stars-controller.js